
import { defineComponent, PropType, ref } from 'vue';
import { directive as onClickaway } from 'vue-clickaway';

const isOpen = ref(false);

export type ActionItem = {
    id: string;
    title: '';
};

export default defineComponent({
    name: 'KebabMenu',
    directives: { onClickaway },
    props: {
        items: {
            type: Array as PropType<ActionItem[]>,
            required: true,
        },
    },
    methods: {
        handleClickOutside(event: Event) {
            isOpen.value = false;
        },
        handleSelectItem(item: ActionItem) {
            this.$emit('itemSelected', item);
            isOpen.value = false;
        },
    },
    setup() {
        const toggleMenu = () => {
            isOpen.value = !isOpen.value;
        };

        return {
            isOpen,
            toggleMenu,
        };
    },
});
